import { useState, useEffect, useCallback, useMemo } from 'react';
const BUFFER_LIMITS = { m: { min: 0.5, max: 100 }, ft: { min: 2, max: 350 } };
export function useBufferConfig() {
    const [bufferEnabled, setBufferEnabled] = useState(false);
    const [bufferDistance, setBufferDistance] = useState('');
    const [bufferUnit, setBufferUnit] = useState('ft');
    const [bufferError, setBufferError] = useState(null);
    useEffect(() => {
        if (!bufferEnabled || !bufferDistance) {
            setBufferError(null);
            return;
        }
        const value = parseFloat(bufferDistance);
        if (isNaN(value)) {
            setBufferError('Please enter a valid number');
            return;
        }
        const limits = BUFFER_LIMITS[bufferUnit];
        if (value < limits.min || value > limits.max) {
            setBufferError(`Must be between ${limits.min} and ${limits.max} ${bufferUnit}`);
            return;
        }
        setBufferError(null);
    }, [bufferEnabled, bufferDistance, bufferUnit]);
    const handleBufferUnitChange = useCallback((unit) => {
        if (unit === bufferUnit)
            return;
        if (bufferDistance) {
            const currentValue = parseFloat(bufferDistance);
            if (!isNaN(currentValue)) {
                const newValue = unit === 'ft' ? currentValue / 0.3048 : currentValue * 0.3048;
                const rounded = unit === 'ft' ? Math.round(newValue) : Math.round(newValue * 10) / 10;
                setBufferDistance(rounded.toString());
            }
        }
        setBufferUnit(unit);
    }, [bufferUnit, bufferDistance]);
    const bufferConfig = useMemo(() => ({
        enabled: bufferEnabled,
        distance: bufferDistance,
        unit: bufferUnit,
        error: bufferError
    }), [bufferEnabled, bufferDistance, bufferUnit, bufferError]);
    return {
        bufferEnabled,
        setBufferEnabled,
        bufferDistance,
        setBufferDistance,
        bufferUnit,
        bufferError,
        handleBufferUnitChange,
        bufferConfig,
    };
}
